<script>
import axios from "axios";
import CSCLookup from "../../utils/csc-lookup";

export default {
  name: 'CountryStateCounty',
  data() {
    return {
      listingItems: [],
      currentPage: [],
      parameters: [],
      currentPageNum: 1,
      responseData: [],
      states: [],
      provinces: [],
      search: "",
      counties: [],
      canadaCounties: [],
      stateProvinces: [],
      totalPages: 0,
      countries: [],
      filteredData: [],
      itemsToRemove: [],
      selectedCountry: "",
      selectedState: "",
      selectedCounty: "",
      totalResults: "",
      inViewIndex: 12,
      canadaCountyList: null,
      provinceList: null,
      country: "",
      geolocate: null,
      initialized: false,
      loading: false,
      selectedSalesforceId: "",
      unSelectedValues: false,
      reset: false,
      submitted: false,
      fetched: false,
      lookupObjects: [],
    };
  },
  props: {
    dataUrl: String,
    dataFormUrl: String,
    mode: String,
    suppressScroll: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    canSelectCounty() {
      if (this.selectedCountry === "Canada") {
        return false;
      } else {
        if (this.selectedState !== "") {
          return true;
        }
      }
    },
  },
  mounted() {
    window.dataLayer = window.dataLayer || [];
    this.fetchListing(1);
    window.addEventListener("failedRepSubmit", (event) => {
      this.unSelectedValues = true;

      this.reset = true;
      this.submitted = true;
      setTimeout(() => {
        this.reset = false;
      }, 500);
    });
  },
  created() {
    axios.interceptors.request.use(
      (config) => {
        // trigger 'loading=true' event here
        this.loading = true;
        return config;
      },
      (error) => {
        // trigger 'loading=false' event here
        this.loading = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        this.loading = false;
        return response;
      },
      (error) => {
        this.loading = false;
        return Promise.reject(error);
      }
    );
  },
  methods: {
    fetchListing(page, inViewIndex) {
      let qs = `?page=${page}`;

      this.states = [];
      this.counties = [];
      this.provinces = [];

      if (this.fetched) {
        this.filterDataBySelections();
      } else {
        this.$nextTick(() => {
          this.countries = [];
          axios.get(`${this.$props.dataUrl}${qs}`).then((response) => {
            this.responseData = response.data;
            this.fetched = true;

            this.lookupObjects = new CSCLookup(this.responseData);

            this.countries = this.lookupObjects.getCountries();

            this.countries = Array.from(this.countries).sort((a, b) => {
              let nameA = a.toUpperCase(); // ignore upper and lowercase
              let nameB = b.toUpperCase(); // ignore upper and lowercase
              if (nameA > nameB) {
                return -1;
              }
              if (nameA < nameB) {
                return 1;
              }
              // names must be equal
              return 0;
            });

            this.filterDataBySelections();
            this.$nextTick(() => {});
          });
        });
      }
    },

    onChangeCountry(event) {
      this.initialized = true;
      this.selectedCountry = event.target.value;
      this.selectedState = "";
      this.selectedCounty = "";
      window.dataLayer.push({
        event: "filter",
        filter_type: "Country",
        selection: this.selectedCountry,
      });
      this.fetchListing(this.currentPageNum, this.inViewIndex);
    },
    onChangeState(event) {
      this.initialized = true;
      this.selectedState = event.target.value;
      // this.countyList = null;
      // this.provinceList = null;
      this.selectedCounty = "";
      window.dataLayer.push({
        event: "filter",
        filter_type: "State",
        selection: this.selectedState,
      });
      this.fetchListing(this.currentPageNum, this.inViewIndex);
    },
    onChangeProvince(event) {
      this.initialized = true;
      this.selectedState = event.target.value;
      this.selectedCounty = "";
      window.dataLayer.push({
        event: "filter",
        filter_type: "Province",
        selection: this.selectedState,
      });
      this.fetchListing(this.currentPageNum, this.inViewIndex);
    },
    onChangeCounty(event) {
      this.initialized = true;
      this.selectedCounty = event.target.value;
      window.dataLayer.push({
        event: "filter",
        filter_type: "County",
        selection: this.selectedCounty,
      });
      this.fetchListing(this.currentPageNum, this.inViewIndex);
    },
    filterDataBySelections() {
      let filteredData = [];

      if (this.selectedCountry) {
        if (this.selectedCountry === "United States") {
          this.states = this.lookupObjects.getTerritoriesByCountry(
            this.selectedCountry
          );
        } else {
          this.provinces = this.lookupObjects.getTerritoriesByCountry(
            this.selectedCountry
          );
        }
        this.responseData.forEach((item) => {
          item.Locations.forEach((location) => {
            if (
              location.Country.toLowerCase() ==
              this.selectedCountry.toLowerCase()
            ) {
              filteredData.push(item);
            }
          });
        });
        this.selectedSalesforceId = filteredData[0].SalesforceId;
      }

      if (this.selectedState) {
        this.counties = this.lookupObjects.getCountiesByTerritory(
          this.selectedCountry,
          this.selectedState
        );
        filteredData = filteredData.filter((item) => {
          let stateFound = false;
          item.Locations.forEach((location) => {
            if (
              location.State.toLowerCase() === this.selectedState.toLowerCase()
            ) {
              stateFound = true;
            }
          });
          return stateFound;
        });
        this.selectedSalesforceId = filteredData[0].SalesforceId;
      }

      if (this.selectedCounty) {
        filteredData = filteredData.filter((item) => {
          let countyFound = false;
          item.Locations.forEach((location) => {
            if (location.County.contains(this.selectedCounty)) {
              countyFound = true;
            }
          });
          return countyFound;
        });
      }
      this.filteredData = filteredData;
      if (this.filteredData.length === 0) {
        this.filteredData = [...this.responseData];
      }

      if (this.search) {
        this.filteredData = this.filteredData.filter((element) => {
          if (
            element.Title &&
            element.Title.toLowerCase().includes(this.search.toLowerCase())
          ) {
            return true;
          } else {
            if (
              element.First_Name.toLowerCase().includes(
                this.search.toLowerCase()
              ) ||
              element.Last_Name.toLowerCase().includes(
                this.search.toLowerCase()
              ) ||
              (
                element.First_Name.toLowerCase() +
                " " +
                element.Last_Name.toLowerCase()
              ).includes(this.search.toLowerCase())
            ) {
              return true;
            } else {
              return false;
            }
          }
        });
      }
      if (this.filteredData.length > 1) {
        this.filteredData = this.filteredData.filter((element) => {
          return !element.SecondarySalesContact;
        });
      }

      this.selectedSalesforceId = this.filteredData[0].SalesforceId;
      this.totalPages = Math.ceil(this.filteredData.length / 12) + 1;
      this.totalResults = this.filteredData.length;
      this.currentPage = this.filteredData.slice(0, this.inViewIndex);
    },
  },
};
</script>
